import {
  IRulesAssessmentOverrideTypeEnum,
  IRulesAssessmentOverrideResultEnum,
} from 'types/graphqlTypes'
import { TRANSFIX_RULE_KEYS } from '../constants'
import { IRulesAssessmentFragment } from '../graphql/RulesAssessmentFragment'
import { TDecision } from './types'

const getTypeFromname = (name: string) =>
  TRANSFIX_RULE_KEYS.includes(name)
    ? IRulesAssessmentOverrideTypeEnum.TransfixRule
    : IRulesAssessmentOverrideTypeEnum.HighwayRule

const getResultFromDecision = (decision: TDecision) =>
  decision === 'pass'
    ? IRulesAssessmentOverrideResultEnum.pass
    : IRulesAssessmentOverrideResultEnum.fail

export const getOverrideInput = (
  name: string,
  decision: TDecision,
  allRules: IRulesAssessmentFragment[]
) => {
  const assessmentRule = allRules.find(({ ruleName }) => ruleName === name)

  const rulesAssessmentId = assessmentRule?.id || ''
  const rulesAssessmentType = getTypeFromname(name)
  const result = getResultFromDecision(decision)

  return {
    rulesAssessmentId,
    rulesAssessmentType,
    result,
  }
}
